import styled, { css } from 'styled-components/macro';

import { Card, ParagraphMd } from '@olist/design-system';

export const CustomCard = styled(Card)`
  margin-top: 20px;

  ${({ messageColor }) => css`
    p {
      color: ${messageColor};
    }
  `}
`;

export const CustomText = styled(ParagraphMd)`
  margin-left: 10px;
`;
